import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FormattedMessageWrappedInSpan from './FormattedMessageWrappedInSpan';

const ShowDownloadFormButton = (props) => {
  const { fullWidth, onShowFormButtonClick } = props;

  return (
    <div
      className={classNames('download-component-container', {'full-width': fullWidth,})}
    >
      <button className="download-component-main" onClick={onShowFormButtonClick}>
        <FormattedMessageWrappedInSpan
          id="downloadDropdown.mainLabel.video"
          defaultMessage="Download video"
        />
      </button>
    </div>
  );
}

ShowDownloadFormButton.propTypes = {
  fullWidth: PropTypes.bool,
  onShowFormButtonClick: PropTypes.func
};

export default ShowDownloadFormButton;